import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="container">
      <h1>Datenschutzerklärung</h1>
      <p>
        Wir – My deserve – sind für die Datenbearbeitung nach dieser Datenschutzerklärung verantwortlich. Der sorgfältige Umgang mit Ihren Personendaten und deren Schutz ist uns ein sehr wichtiges Anliegen.
        <br />
        <br />
        Diese Datenschutzerklärung gilt für die gesamten Online-Aktivitäten zwischen uns und den Besuchern unserer Webseiten sowie unserer App («www.mydeserve.ch» und «https://app.mydeserve.ch» bzw. die entsprechende «mydeserve»-Applikation).  Für einzelne oder zusätzliche Angebote und Leistungen können besondere oder ergänzende Datenschutzerklärungen, Allgemeine Geschäftsbedingungen (AGB), Nutzungsbedingungen oder Teilnahmebedingungen gelten, auf die wir Sie an geeigneter Stelle hinweisen.
      </p>
      <h4>I. Rechtliche Rahmenbedingungen der Datenbearbeitung</h4>
      <p>
        Bei der Bearbeitung Ihrer Personendaten kommen das Bundesgesetz über den Datenschutz (DSG) und die dazugehörigen Verordnungen zur Anwendung. Wir halten die Vorgaben dieser gesetzlichen Erlasse ein und gehen sorgfältig und verantwortungsbewusst mit Ihren Daten um. Darüber hinaus richten wir uns wo angemessen nach den Vorgaben der EU-DSGVO, ohne rechtlich dazu verpflichtet zu sein.
      </p>

      <h4>II. Welche Daten erheben wir?</h4>
      <p>
        Wir erhalten, sammeln und speichern alle Informationen, die Sie auf unserer Website oder in unserer App eingeben oder uns auf andere Weise zur Verfügung stellen. Wir sammeln insbesondere auch persönlich identifizierbare Informationen, einschliesslich Login, E-Mail, Passwort sowie Kommunikation mit uns. Darüber hinaus erfassen wir die Internet-Protokoll-Adresse (IP-Adresse), die für die Verbindung Ihres Computers mit dem Internet verwendet wird sowie Computer- und Verbindungsinformationen.
        <br />
        <br />
        Wir können Software-Tools verwenden, um Sitzungsinformationen zu messen und zu erfassen, einschließlich der Antwortzeiten auf Seiten, der Dauer der Besuche auf bestimmten Seiten, Informationen zur Seiteninteraktion und der Methoden, die zum Verlassen der Seite verwendet werden.
        <br />
        <br />
        Wir erheben zudem Daten zum Nutzungsverhalten auf unserer App, insbesondere welche Promotionen angewählt und via Soziale Medien geteilt werden sowie ob die erforderliche Anzahl «Likes» erzielt wird oder nicht.
      </p>

      <h4>III. Zwecke der Datenbearbeitung </h4>
      <p>
        Generell werden Ihre Daten bearbeitet, um die Nutzung unserer Plattform zu ermöglichen und die Dienstleistungen zu verbessern. Dies umfasst die Verwaltung von Nutzerkonten, die Durchführung von Aktionen sowie die Erfüllung von Vereinbarungen mit Unternehmen und Nutzern.
        <br />
        <br />
        Wir bearbeiten Ihre Personendaten somit in erster Linie:
        <ul>
          <li>
            Um unsere Dienste bereitzustellen und zu betreiben;
          </li>
          <li>
            Um unseren Nutzern kontinuierliche Kundenbetreuung und technischen Support zu bieten;
          </li>
          <li>
            Um unsere Besucher und Benutzer mit allgemeinen oder personalisierten dienstbezogenen Mitteilungen und Werbebotschaften zu kontaktieren;
          </li>
          <li>
            Falls ein Vertrag abgeschlossen wird, für den Abschluss und die Erfüllung dieses Vertrages;
          </li>
          <li>
            Um aggregierte statistische Daten sowie andere aggregierte und/oder abgeleitete nicht-personenbezogene Informationen zu erstellen, die wir oder unsere Geschäftspartner zur Bereitstellung und Verbesserung unserer Dienste verwenden können;
          </li>
          <li>
            Für Marketingzwecke (z.B. Übermittlung von Informationen und Werbung von uns sowie von Dritten bzw. für Dritte, etwa als Newsletter oder Drucksache, gezielte Ansprache bestehender Nutzer). Dabei verwenden wir insbesondere Stamm- und Kommunikationsdaten sowie Verhaltens- und Präferenzdaten. Der Bearbeitung zu Marketingzwecken kann jederzeit widersprochen bzw. eine erteilte Einwilligung widerrufen werden;
          </li>
          <li>
            Wenn es der Wahrung berechtigter Interessen dient (z.B. Gewährleistung der IT-Sicherheit, Geltendmachung rechtlicher Ansprüche);
          </li>
          <li>
            Wenn die Datenbearbeitung auf einer wirksamen Einwilligung beruht;
          </li>
          <li>
            Wenn die Datenbearbeitung zur Einhaltung gesetzlicher Verpflichtungen erforderlich ist.
          </li>
        </ul>
        <br />
        Soweit Sie uns eine Einwilligung zur Bearbeitung Ihrer Personendaten für bestimmte Zwecke erteilt haben (zum Beispiel bei Ihrer Anmeldung zum Erhalt von Newslettern oder anderen Anträgen über Online-Formulare auf unserer Website), bearbeiten wir Ihre Personendaten im Rahmen und gestützt auf diese Einwilligung, wenn wir keine andere Rechtsgrundlage haben und wir eine solche benötigen. Eine erteilte Einwilligung kann jederzeit widerrufen werden, was jedoch keine Auswirkung auf bereits erfolgte Datenbearbeitungen hat.
      </p>
      <h4>IV. Cookies / Tracking und andere Technologien </h4>
      <p>
        Unsere Websites verwenden Cookies und ähnliche Tracking-Technologien, um die Benutzerfreundlichkeit zu verbessern und die Nutzung der Webseite zu analysieren. Ein Cookie ist eine kleine Datei, die an Ihren Computer gesendet bzw. vom verwendeten Webbrowser automatisch auf Ihrem Computer oder mobilen Gerät gespeichert wird, wenn Sie unsere Website besuchen. Dabei ist zu beachten, dass die Cookie-Namen je nach Gerät und Browser variieren können. Die folgenden Cookies werden verwendet:
        <br />
        <br />
        <strong>Unbedingt erforderliche Cookies:</strong> Wir verwenden aussschliesslich Cookies, welche für die Funktion des Online-Angebots notwendig sind.
        {/*
        <strong>Unbedingt erforderliche Cookies:</strong> Bestimmte Cookies sind für die Funktion des Online-Angebots notwendig.
        <br />
        <br />
        <strong>Leistungs-Cookies:</strong> Wir setzen Cookies ein, die Angaben über die Verwendung unseres Online-Angebots erfassen und analysieren, damit wir Inhalt und Präsentation unseres Online-Angebots verbessern und auf die Benutzer abstimmen können. Auch diese Cookies können über einen Besuch hinaus gespeichert bleiben.
        <br />
        <br />
        <strong>Funktionelle Cookies:</strong> Diese Cookies ermöglichen uns die Bereitstellung erweiterter Funktionalitäten und die Personalisierung von z.B. Formularfeldern.
        */}<br />
        <br />
        <strong>Plug-ins von sozialen Netzwerken</strong>
        <br />
        Wir setzen auf unseren Websites ferner sog. Plug-ins von sozialen Netzwerken wie Facebook, X, und LinkedIn. Das ist für Sie jeweils ersichtlich (typischerweise über entsprechende Symbole). Wir haben diese Elemente so konfiguriert, dass sie standardmässig deaktiviert sind. Aktivieren Sie sie (durch Anklicken), können die Betreiber der jeweiligen sozialen Netzwerke registrieren, dass Sie auf unserer Website sind und wo und können diese Informationen für ihre Zwecke nutzen. Die Bearbeitung Ihrer Personendaten erfolgt dann in Verantwortung dieses Betreibers nach dessen Datenschutzbestimmungen. Wir erhalten von ihm keine Angaben zu Ihnen.
      </p>
      <h4>V. Datenempfänger</h4>
      <p>
        Wir können Daten nach Ziff. II insbesondere an folgende Kategorien von Empfängern bekanntgeben, soweit dies für die Zwecke nach Ziff. III jeweils erforderlich ist:
        <br />
        <br />
        <strong>Partnerunternehmen von My deserve:</strong> Ihre Daten können an Drittunternehmen weitergegeben werden, die My deserve als Anbieter nutzen und ihre zu verdienenden Gratisinhalte auf die Plattform von My deserve hochladen.
        <br />
        <br />
        <strong>Externe Dienstleister:</strong> Insbesondere IT-Dienstleister (z.B. Cloud-Dienste, Datenspeicherung (Hosting)).
        <br />
        <br />
        <strong>Behörden und Ämter:</strong> Im Zusammenhang mit der Wahrnehmung von Rechten, der Abwehr von Forderungen und der Erfüllung rechtlicher Anforderungen können wir Daten u.U. an Behörden, Ämter, Gerichte und andere öffentliche Stellen weitergeben, wenn dies zur Wahrung unserer Rechte erforderlich ist. Die Behörden bearbeiten in eigener Verantwortlichkeit Daten über Sie, die sie von uns erhalten.
        <br />
        <br />
        <strong>Weitere Dritte:</strong>  Z.B. Werbe-Vertragspartner, Social-Media-Anbieter, Videoplattformen-Anbieter sowie Dienstleister, welche bei der Durchführung oder Organisation von Veranstaltungen involviert sind.
        <br />
        <br />
        Diese Empfänger können sich in der Schweiz oder im Europäischen Wirtschaftsraum (EWR) befinden (z.B. bei der Übermittlung von Personendaten bei der Inanspruchnahme von IT-Dienstleistungen, usw.). Das Niveau des Datenschutzes im EWR ist mit demjenigen in der Schweiz vergleichbar. Durch eine Weitergabe von Personendaten an Dritte im EWR ist der verantwortungsvolle und sichere Umgang mit Ihren Daten nicht eingeschränkt.
      </p>
      <h4>VI. Datensicherheit</h4>
      <p>
        Wir treffen angemessene Sicherheitsmassnahmen technischer Natur (z.B. Verschlüsselung, Protokollierung, Zugriffsbeschränkung, Datensicherung etc.) und organisatorischer Natur (z.B. Weisungen an unsere Mitarbeitenden, Überprüfungen etc.), um die Sicherheit Ihrer Personendaten zu wahren und sie gegen unberechtigte oder unrechtmässige Bearbeitungen zu schützen und der Gefahr des Verlusts, einer unbeabsichtigten Veränderung, einer ungewollten Offenlegung oder eines unberechtigten Zugriffs entgegenzuwirken. Bitte beachten Sie, dass trotz dieser Massnahmen eine 100% Datensicherheit nicht realistisch ist.
      </p>
      <h4>VII. Dauer der Aufbewahrung</h4>
      <p>
        Wir speichern Ihre Personendaten, solange es für den konkreten Zweck, für den wir sie erhoben haben, erforderlich ist, mindestens jedoch so lange, wie es die gesetzlichen Aufbewahrungsfristen vorsehen. Wir speichern Personendaten ferner, solange wir ein berechtigtes Interesse an der Speicherung haben (z.B. für die Durchsetzung von Rechtsansprüchen, zu Archivierungszwecken oder Gewährleistung der IT-Sicherheit). Anschliessend löschen oder anonymisieren wir Ihre Personendaten.
      </p>
      <h4>VIII. Ihre Rechte</h4>
      <p>
        Die folgenden Rechte stehen Ihnen in Bezug auf Ihre Personendaten zu:
      <ul>
          <li>
            Auskunft über bearbeitete Personendaten
          </li>
          <li>
            Berichtigung, Ergänzung, Sperrung oder Löschung Ihrer Personendaten
          </li>
          <li>
            Widerspruch gegen die Verwendung Ihrer Daten
          </li>
          <li>
            Widerruf Ihrer Einwilligung für künftige Datenbearbeitungen (z.B. Newsletter abbestellen)
          </li>
          <li>
            Übertragung Ihrer Daten
          </li>
        </ul>
        <br />
        Bitte beachten Sie, dass wir uns vorbehalten, unsererseits die gesetzlich vorgesehenen Einschränkungen geltend zu machen. Etwa, wenn wir zur Aufbewahrung oder Bearbeitung gewisser Daten verpflichtet sind, daran ein überwiegendes Interesse haben (soweit wir uns darauf berufen dürfen) oder sie für die Geltendmachung von Ansprüchen benötigen.
        <br />
        <br />
        Sie können jederzeit von Ihren Rechten Gebrauch machen, indem Sie sich an die unter nachfolgender Ziffer IX genannte Stelle wenden. Die Ausübung solcher Rechte setzt in der Regel voraus, dass Sie Ihre Identität eindeutig nachweisen (z.B. durch eine Ausweiskopie, wo Ihre Identität sonst nicht klar ist bzw. verifiziert werden kann).Falls notwendig, werden wir Sie auch für die Bearbeitung anderer Anfragen in geeigneter Weise um Identifikation bitten.
      </p>
      <h4>IX. Ihr Kontakt bei Anliegen zum Datenschutz</h4>
      <p>
        Wenn Sie Fragen haben, Zugang zu Ihren persönlichen Daten wünschen oder Rechte in Zusammenhang mit Ihren Personendaten geltend machen möchten, können Sie sich an uns wenden unter:
        <br />
        <br />
        KOOLBROZ GmbH
        <br />
        Anglikerstrasse 58, 5612 Villmergen, Schweiz
        <br />
        E-Mail: <a href="mailto:info@mydeserve.ch">info@mydeserve.ch</a>
        <br />
        Telefon: +41 79 881 36 32
      </p>
      <h4>X. Änderungen</h4>
      <p>
        Wir können diese Datenschutzerklärung jederzeit ohne Vorankündigung anpassen. Es gilt die jeweils aktuelle, auf unserer Website publizierte Fassung. Soweit dies angezeigt erscheint, werden wir Sie im Falle einer Aktualisierung über die Änderung per E-Mail oder auf andere geeignete Weise informieren.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
